import { render } from "./PaginationNext.vue?vue&type=template&id=a502e248&ts=true"
import script from "./PaginationNext.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationNext.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationNext.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a502e248"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a502e248', __exports__)) {
    api.reload('a502e248', __exports__)
  }
  
  module.hot.accept("./PaginationNext.vue?vue&type=template&id=a502e248&ts=true", () => {
    api.rerender('a502e248', render)
  })

}


export default __exports__